import { render } from "./App.vue?vue&type=template&id=7d8d77d0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7d8d77d0&lang=css"
script.render = render

export default script